<style>
  /* Force widget background colors with maximum specificity */
  section.card.dashboard-widget-card.widget-bg-green,
  section.card.widget-bg-green {
    background: #ffffff !important;
    background-color: #ffffff !important;
    border-radius: 35px !important;
  }
  section.card.dashboard-widget-card.widget-bg-red,
  section.card.widget-bg-red {
    background: #ffffff !important;
    background-color: #ffffff !important;
    border-radius: 35px !important;
  }
  section.card.dashboard-widget-card.widget-bg-blue,
  section.card.widget-bg-blue {
    background: #ffffff !important;
    background-color: #ffffff !important;
    border-radius: 35px !important;
  }
  section.card.dashboard-widget-card.widget-bg-purple,
  section.card.widget-bg-purple {
    background: #ffffff !important;
    background-color: #ffffff !important;
    border-radius: 35px !important;
  }
  
  /* Make card-heading transparent for widget cards */
  .dashboard-widget-card .card-heading,
  section.card.dashboard-widget-card .card-heading,
  .widget-bg-green .card-heading,
  .widget-bg-red .card-heading,
  .widget-bg-blue .card-heading,
  .widget-bg-purple .card-heading {
    background: transparent !important;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
  }
  
  /* Ensure 3D shadow effect for Company News and Meetings widgets */
  .company-news-card,
  .allMeetings {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    -webkit-box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    -moz-box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  }
  
  .company-news-card:hover,
  .allMeetings:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2) !important;
    -webkit-box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2) !important;
    -moz-box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2) !important;
  }
</style>
<div class="clearfix"></div>
<!-- Trading Window -->
<div class="row" style="margin: 0;">
  <div class="col-12">
    <div class="trade-window d-flex justify-content-between dashboard-section mb-3"
         *ngIf="enableDashboard && companyData?.Listed">
      <div class="leftblock"
        [appHasPermission]="{'Url': 'stockPrice', 'method':'get', 'menu': 'Dashboard'}">
        <div class="anch-pointer d-flex">
          <label class="mr-4">Trading Window:</label>
          <div *ngIf="selectedStockExchange=='NSE'">
            <div class="row">
              <div *ngIf="tradingWindowStatus=='Off'">
                <span>ON</span>
                <span class="tradeOff">OFF</span>
              </div>
              <div *ngIf="tradingWindowStatus=='On'">
                <span class="tradeOn">ON</span>
                <span>OFF</span>
              </div>
            </div>
          </div>
          <div *ngIf="selectedStockExchange=='BSE'">
            <div class="row">
              <div *ngIf="tradingWindowStatus=='Off'">
                <span>ON</span>
                <span class="tradeOff">OFF</span>
              </div>
              <div *ngIf="tradingWindowStatus=='On'">
                <span class="tradeOff">ON</span>
                <span>OFF</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- EVA, if needed -->
      <!-- <div class="rightblock"><label>EVA: {{companyEVA | number : '1.2-2'}}</label></div> -->
    </div>
  </div>
</div>

<!-- All 4 Widgets in One Full-Width Row -->
<div class="row mb-3" style="margin: 0;">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div [ngClass]="setSubCardClasses(1,2)"
             [appHasPermission]="{'Url': 'stockPrice', 'method':'get', 'menu': 'Dashboard'}">
          <section class="card dashboard-widget-card widget-bg-green" order-id="card-2">
            <div class="card-heading widget-card-content" (click)="openDashboardModal('ShareInfoModal')">
              <div class="widget-icon-wrapper widget-icon-green">
                <img src="/assets/images/share-information.png" alt="share information" class="widget-icon">
              </div>
              <div class="widget-title">Share Information</div>
              <div class="widget-arrow">
                <i class="fa fa-arrow-right"></i>
              </div>
            </div>
            <div class="modal fade" id="ShareInfoModal" tabindex="-1" role="dialog">
              <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" style="background: transparent;">
                  <div class="modal-body">
                    <app-stock-price [data]="companyData"></app-stock-price>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div [ngClass]="setSubCardClasses(1,2)"
             [appHasPermission]="{'Url': 'financialResults', 'method':'get', 'menu': 'Dashboard'}">
          <section class="card dashboard-widget-card widget-bg-red" order-id="card-2">
            <div class="card-heading widget-card-content" (click)="openDashboardModal('FinancialsModal')">
              <div class="widget-icon-wrapper widget-icon-red">
                <img src="/assets/images/financials.png" alt="Financials" class="widget-icon">
              </div>
              <div class="widget-title">Financials</div>
              <div class="widget-arrow">
                <i class="fa fa-arrow-right"></i>
              </div>
            </div>
            <div class="modal fade" id="FinancialsModal" tabindex="-1" role="dialog">
              <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" style="background: transparent;">
                  <div class="modal-body">
                    <app-financials></app-financials>
                    <!-- <app-financial-results></app-financial-results> -->                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12"
           [appHasPermission]="{'Url': 'keyRatios', 'method':'get', 'menu': 'Dashboard'}">
        <section class="card dashboard-widget-card widget-bg-blue" order-id="card-2">
          <div class="card-heading widget-card-content" (click)="openDashboardModal('KeyRatiosModal')">
            <div class="widget-icon-wrapper widget-icon-blue">
              <img src="/assets/images/key-ratios.png" alt="KeyRatios" class="widget-icon">
            </div>
            <div class="widget-title">Key Ratios</div>
            <div class="widget-arrow">
              <i class="fa fa-arrow-right"></i>
            </div>
          </div>
          <div class="modal fade" id="KeyRatiosModal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-xl" role="document">
              <div class="modal-content" style="background: transparent;">
                <div class="modal-body">
                  <app-key-ratios></app-key-ratios>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12"
           [appHasPermission]="{'Url': 'keyRatios', 'method':'get', 'menu': 'Dashboard'}">
        <section class="card dashboard-widget-card widget-bg-purple" order-id="card-2">
          <div class="card-heading widget-card-content" (click)="openDashboardModal('orgChartModal')">
            <div class="widget-icon-wrapper widget-icon-purple">
              <img src="/assets/images/organization-charts.png" alt="orgchart" class="widget-icon">
            </div>
            <div class="widget-title">Organization Chart</div>
            <div class="widget-arrow">
              <i class="fa fa-arrow-right"></i>
            </div>
          </div>
        </section>
        <!-- Organization Chart component has its own modal structure -->
        <app-orgchart></app-orgchart>
      </div>
</div>

<!-- Meetings (Left) and Company News (Right) -->
<div class="row mb-3 company-news-meetings-row" style="margin: 0 -16px 0 -16px; width: calc(100% + 32px);">
  <!-- Meetings - Left Side (Larger Width) -->
  <div class="col-lg-8 col-md-12 p-0" *ngIf="RowOne" style="padding-right: 8px !important; padding-left: 16px !important;">
    <div id="left-col">
      <div class="cat__core__sortable" id="left-center-col">
        <div [appHasPermission]="{'Url': 'myTasks', 'method':'get', 'menu': 'Dashboard'}">
          <app-mytask [refreshStatus]="taskObject" (UpdatedStatus)="updatedTask($event)"></app-mytask>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Company News - Right Side (Smaller Width) -->
  <div class="col-lg-4 col-md-12 p-0" *ngIf="RowOne" style="padding-left: 8px !important; padding-right: 16px !important;">
    <div class="cat__core__sortable" id="left-center-col" style="height: 100%;">
      <div [appHasPermission]="{'Url': 'companyNews', 'method':'get', 'menu': 'Dashboard'}" style="height: 100%;">
        <app-company-news></app-company-news>
      </div>
    </div>
  </div>
</div>

<!-- My Task - Same Width as Meetings Widget -->
<div class="row mb-3" style="margin: 0 -16px 0 -16px; width: calc(100% + 32px);">
  <div class="col-lg-8 col-md-12 p-0" *ngIf="RowFive || RowSix" style="padding-right: 8px !important; padding-left: 16px !important;">
    <div class="cat__core__sortable" id="right-center-col" style="width: 100%; ">
      <app-meeting-assistent-wrapper [refreshData]="taskObject" (outputStatus)="updatedTask($event)"
          [rowFive]="RowFive" [rowSix]="RowSix" [isRocketChatRemove]="isRocketChatRemove">
      </app-meeting-assistent-wrapper>
    </div>
  </div>
</div>

<!-- ESG if needed -->
<div class="row mb-3 dashboard-page esg" *ngIf="isPSSConfig" style="margin: 0;"></div>
<!-- Welcome message when dashboard is not enabled -->
<div class="tab-content" *ngIf="!enableDashboard">
  <section style="background-color: white">
    <h2>Welcome</h2>
  </section>
</div>
<!-- Loading spinner overlay -->
<div *ngIf="showSpinner" style="background-color:transparent"></div>
<!-- Footer (outside dashboard row) -->
<footer class="footer">
  <!-- Footer content here -->
</footer>
